export function audiencePresentation(audience = {}, data = {}) {
  const count =
    audience.identifiers?.length || audience.recipientKeys?.length || 0;
  switch (audience.visibility) {
    case 'public':
      return {
        label: 'Everyone',
        reach: 'Anyone who meets every discovery requirement',
      };
    case 'private':
      return { label: 'Only me', reach: 'Only you' };
    case 'followers':
      return {
        label: 'My followers & subscribers',
        reach:
          data.subscriberCount == null
            ? 'Current and future followers and subscribers'
            : `${data.subscriberCount} current follower${
                data.subscriberCount === 1 ? '' : 's'
              } and subscriber${data.subscriberCount === 1 ? '' : 's'}`,
      };
    case 'named-users':
      return {
        label: audience.requireSubscription
          ? 'Selected followers & subscribers'
          : 'Selected recipients',
        reach: `${count} selected recipient${count === 1 ? '' : 's'}`,
      };
    case 'group':
      return {
        label: 'Group members',
        reach: `${count} selected group${count === 1 ? '' : 's'}`,
      };
    case 'channel':
      return {
        label: 'Channel subscribers',
        reach: `${count} selected channel${count === 1 ? '' : 's'}`,
      };
    case 'topic':
      return {
        label: 'Topic subscribers',
        reach: `${count} selected topic${count === 1 ? '' : 's'}`,
      };
    default:
      return {
        label: 'Saved audience',
        reach: 'Your existing audience rules apply',
      };
  }
}
